import React from 'react'
import {
  LayoutWithStandardHeader,
  Container,
  Row,
  color,
  spacer
} from 'stylist'
import styled from 'react-emotion'

const Footer = styled(LayoutWithStandardHeader.Footer)`
  background-color: ${color('white')};
  margin-top: ${spacer(4)};
`

const FooterContainer = styled(Container)`
  text-align: center;
  color: ${color('pewter')};
  padding-top: ${spacer(5)};
  padding-bottom: ${spacer(5)};
`

const FeedbackLink = styled.a`
  color: ${color('ocean')};
  margin-left: ${spacer(2)};
  text-decoration: underline;
`

const MainFooter = () => (
  <Footer>
    <Row>
      <FooterContainer>
        Want to help train our robots, or have feedback to share?
        <FeedbackLink href="mailto:FVAnalytics@focusvision.com">
          FVAnalytics@focusvision.com
        </FeedbackLink>
      </FooterContainer>
    </Row>
  </Footer>
)

export default MainFooter



// WEBPACK FOOTER //
// ./src/components/MainFooter.js